import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_57: DocMigration = {
  maxSchemaVersion: "0.0.57",
  description: "support for editting all the awning settings per individual door/window",
  apply(json: any) {
    const allSettings = json.settings;
    for (const settingsId in allSettings) {
      const settings = allSettings[settingsId];
      if (settings.type !== "AWNING_SETTINGS") {
        continue;
      }

      if (settings.roofMat === undefined) {
        continue;
      }

      settings.roofMaterial = settings.roofMat;
      delete settings.roofMat;
    }

    return json;
  },
};

export default migration_0_0_57;
